<template>
  <div class = "noneBox">
    <p>{{noData}}</p>
  </div>
</template>

<script>
export default {
  name: 'noneBox',
    props:['noData', 'padding'],
  data () {
    return {
      
    }
  },
  methods: {
  	demo_fun () {

  	}
  },
  created(){
  	
  }
}
</script>

<style scoped>
.noneBox{background: url('../../../static/image/noData.png') no-repeat center 130px;background-size:178px auto}
.noneBox p{font-size:24px;color:#6770e6;padding:260px 0 100px;text-align:center}
</style>



// WEBPACK FOOTER //
// src/components/common/None.vue